import React, { ReactElement } from 'react';

interface Props {
  width?: string;
  height?: string;
}

const Pending = (props: Props): ReactElement => {
  const { width, height } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 200 200">
      <defs>
        <circle id="o99bnj8rba" cx="99.59" cy="99.59" r="99.59" />
      </defs>
      <g fill="#f4f7fc" fillRule="evenodd">
        <g>
          <g>
            <g transform="translate(-460 -217) translate(290 137) translate(170 80)">
              <mask id="holb6dn8nb" fill="#fff">
                <use xlinkHref="#o99bnj8rba" />
              </mask>
              <circle
                cx="99.59"
                cy="99.59"
                r="99.34"
                stroke="#DCDFE3"
                strokeWidth=".5"
              />
              <g
                stroke="#23303E"
                strokeLinecap="round"
                strokeWidth="2.5"
                mask="url(#holb6dn8nb)"
              >
                <g>
                  <path
                    strokeDasharray="8 16"
                    d="M0 8.698L60 8.698"
                    transform="translate(-14 35)"
                  />
                  <path
                    d="M1 .5L61 .5M126 139.802L202 139.802"
                    transform="translate(-14 35)"
                  />
                  <path
                    strokeDasharray="8 16"
                    d="M119 148L195 148"
                    transform="translate(-14 35)"
                  />
                </g>
              </g>
              <path
                fill="#0074CC"
                fillRule="nonzero"
                d="M132.286 31.444c13.345 0 24.163 10.666 24.163 23.823 0 13.156-10.818 23.822-24.163 23.822s-24.164-10.666-24.164-23.822c0-13.157 10.819-23.823 24.164-23.823zM119 50c-2.761 0-5 2.239-5 5s2.239 5 5 5 5-2.239 5-5-2.239-5-5-5zm14 0c-2.761 0-5 2.239-5 5s2.239 5 5 5 5-2.239 5-5-2.239-5-5-5zm14 0c-2.761 0-5 2.239-5 5s2.239 5 5 5 5-2.239 5-5-2.239-5-5-5z"
                mask="url(#holb6dn8nb)"
              />
              <circle
                cx="118"
                cy="56"
                r="4.25"
                stroke="#23303E"
                strokeWidth="2.5"
                mask="url(#holb6dn8nb)"
              />
              <circle
                cx="132"
                cy="56"
                r="4.25"
                stroke="#23303E"
                strokeWidth="2.5"
                mask="url(#holb6dn8nb)"
              />
              <circle
                cx="146"
                cy="56"
                r="4.25"
                stroke="#23303E"
                strokeWidth="2.5"
                mask="url(#holb6dn8nb)"
              />
              <path
                fill="#0074CC"
                fillRule="nonzero"
                d="M149.14 127.508v-25.431l.9 1.392c1.278 1.994 3.04 4.814 5.288 8.46 2.777 4.505 2.29 8.55-1.46 12.133l-.233.22-4.496 3.226zM54.3 49.415v52.038L36.9 71.362c-3.195-5.623-2.31-9.939 2.654-12.947 4.964-3.009 9.88-6.009 14.747-9z"
                mask="url(#holb6dn8nb)"
              />
              <path
                fillRule="nonzero"
                stroke="#23303E"
                strokeWidth="2.5"
                d="M131.286 26.25c8.414 0 16.033 3.361 21.548 8.798 5.508 5.43 8.916 12.932 8.916 21.219 0 10.816-5.806 20.292-14.508 25.575l-.392.234-.215 61.198c0 3.951-1.611 7.532-4.221 10.143-2.532 2.533-6.002 4.154-9.856 4.319l-.4.012-64.177.002c-4.026 0-7.676-1.587-10.337-4.162-2.566-2.485-4.212-5.89-4.38-9.672l-.012-.393-.002-94.608c0-3.952 1.612-7.533 4.221-10.143 2.532-2.533 6.002-4.154 9.856-4.32l.4-.011 42.647-.003c5.483-5.087 12.83-8.188 20.912-8.188zm-25.534 13.552H67.981l-.328.006c-2.393.082-4.553 1.062-6.149 2.632-1.655 1.629-2.704 3.894-2.764 6.46h0v94.374l.006.323c.084 2.365 1.081 4.501 2.683 6.078 1.649 1.622 3.94 2.653 6.537 2.712h63.938l.328-.006c2.393-.082 4.553-1.062 6.149-2.632 1.655-1.629 2.704-3.895 2.764-6.46h0V84.532l-.579.182c-3.074.946-5.955 1.57-9.28 1.57-8.415 0-16.034-3.362-21.548-8.799-5.508-5.43-8.917-12.931-8.917-21.218 0-5.832 1.691-11.273 4.931-16.465h0zm21.494 90.484c.76 0 1.45.302 1.949.793.491.483.797 1.15.797 1.889 0 .738-.306 1.405-.797 1.889-.454.446-1.064.736-1.743.785l-.206.007h-54.6c-.761 0-1.45-.302-1.95-.792-.49-.484-.796-1.151-.796-1.89 0-.738.306-1.405.797-1.888.453-.446 1.064-.736 1.743-.785l.205-.008h54.601zm0-16.238c.76 0 1.45.302 1.949.792.491.484.797 1.151.797 1.89 0 .738-.306 1.405-.797 1.889-.454.446-1.064.736-1.743.785l-.206.007h-54.6c-.761 0-1.45-.302-1.95-.792-.49-.484-.796-1.151-.796-1.89 0-.738.306-1.405.797-1.889.453-.446 1.064-.736 1.743-.785l.205-.007h54.601zm0-16.238c.76 0 1.45.302 1.949.792.491.484.797 1.151.797 1.89 0 .738-.306 1.405-.797 1.888-.454.446-1.064.736-1.743.786l-.206.007h-54.6c-.761 0-1.45-.302-1.95-.793-.49-.483-.796-1.15-.796-1.889 0-.738.306-1.405.797-1.889.453-.446 1.064-.736 1.743-.785l.205-.007h54.601zM99.575 81.572c.76 0 1.45.301 1.948.792.491.483.797 1.15.797 1.89 0 .737-.306 1.405-.797 1.888-.453.446-1.064.736-1.743.785l-.205.008h-26.93c-.76 0-1.45-.302-1.948-.793-.491-.483-.797-1.15-.797-1.889 0-.738.306-1.406.797-1.889.453-.446 1.064-.736 1.743-.785l.205-.007h26.93zm31.71-50.378c-7.015 0-13.366 2.805-17.963 7.338-4.604 4.538-7.45 10.81-7.45 17.735 0 6.925 2.846 13.196 7.45 17.735 4.597 4.532 10.948 7.337 17.964 7.337 7.015 0 13.366-2.805 17.963-7.337 4.604-4.54 7.45-10.81 7.45-17.735 0-6.926-2.846-13.197-7.45-17.735-4.597-4.533-10.948-7.338-17.963-7.338zm-43.288 34.14c.76 0 1.45.301 1.948.792.491.483.797 1.15.797 1.889 0 .738-.306 1.406-.797 1.889-.453.446-1.064.736-1.743.785l-.205.008H72.645c-.76 0-1.45-.302-1.948-.793-.491-.483-.797-1.15-.797-1.89 0-.737.306-1.405.797-1.888.453-.446 1.064-.736 1.743-.785l.205-.008h15.352z"
                mask="url(#holb6dn8nb)"
              />
              <path
                fillRule="nonzero"
                stroke="#23303E"
                strokeWidth="2.5"
                d="M109.532 158.25l-11.755 6.787c-3.487 2.013-7.441 2.464-11.033 1.564-3.585-.899-6.808-3.143-8.836-6.52h0l-1.059-1.831h6.458c1.298 1.622 3.084 2.703 5.031 3.156 2.143.498 4.48.235 6.567-.907h0l3.9-2.25h10.727zm37.717-64.834l11.406 19.757c1.976 3.422 2.371 7.33 1.416 10.895-.957 3.579-3.274 6.814-6.716 8.878h0l-6.106 3.527v-6.193l3.206-1.85c2.17-1.253 3.646-3.242 4.289-5.455.648-2.234.449-4.697-.738-6.87h0l-6.757-11.707V93.416zm-94.326-44.87c-.089.624-.144 1.26-.164 1.905h0l-.009.539v3.849L38.802 62.89c-2.171 1.253-3.647 3.242-4.29 5.456-.648 2.234-.448 4.696.739 6.869h0l17.497 30.312v10.981L30.602 78.15c-1.976-3.423-2.37-7.33-1.416-10.895.958-3.58 3.274-6.814 6.716-8.879h0z"
                mask="url(#holb6dn8nb)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

Pending.defaultProps = {
  width: '100%',
  height: '100%',
};

export default Pending;
